import { Component, Input } from '@angular/core';
import { User } from '../user.model';
import { NgClass } from '@angular/common';

@Component({
  selector: 'fnsr-user-item',
  standalone: true,
  imports: [NgClass],
  templateUrl: './user-item.component.html',
  styleUrls: ['./user-item.component.scss']
})
export class UserItemComponent {
  @Input() user: User | undefined;
  @Input() size: number | undefined;

}
